import {
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography,
  OutlinedInput,
  FormHelperText,
  useTheme,
  useMediaQuery,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import React from "react";
import { Link, useHistory } from "react-router-dom";
import { Buffer } from 'buffer';
import CloseIcon from "@mui/icons-material/Close";
import theme, { linkStyle, linkStyle1, noArrows, red_border } from "../../theme";
import { ActionButton } from "../ActionButton/ActionButton";
import { useTranslation } from "react-i18next";
import { selectLanCode } from "../Language/LanguageSlice";
import axios from "axios";
import { MAIN_URL, login } from "../../redux/UserAPI";
import { VisibilityOff, Visibility } from "@mui/icons-material";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { isLoading } from "../../redux/UserSlice";

export function Login(props: any) {
  const dispatch = useAppDispatch();
  const language = useAppSelector(selectLanCode);
  const isLoadingUserSlice = useAppSelector(isLoading)

  const { setLogin } = props

  const notRobot =  "I am not a robot";
  const [regNumber, setRegNumber] = React.useState<number|string>('');
  const [password, setPassword] = React.useState<string>("");
  const [showPassword, setShowPassword] = React.useState<boolean>(false);
  const [isRobot, setIsRobot] = React.useState<boolean>(false);
  const [err, setErr] = React.useState<string>("");
  const history = useHistory();
  const submit = async () => {
    if (regNumber && !/^[0-9]{7}$/.test(regNumber?.toString()) || !regNumber)  {
      const err_msg = "Please enter a valid registration number"
      return setErr(err_msg);
    }
    if (!password || "") {
      const err_msg = "Please enter a valid password"
      return setErr(err_msg);
    }

    if (!isRobot) {
      const err_msg = "Please confirm that you are not a robot";
      return setErr(err_msg);
    }
    console.log('login')
    const args = { regNumber: regNumber, password:  Buffer.from(password).toString('base64')};
    console.log(args)

    const res:any = await dispatch(login(args))
    console.log(res)
    if (!res.error) {
      history.push("/user_page");
    }

  };


  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('lg'));

  return (
<> <Backdrop
              sx={{
                zIndex: 8000,
                color: "#fff",
              }}
              open={isLoadingUserSlice}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
    <Paper sx={{padding: !matches ? 0 : 2}}>
      <IconButton onClick={() => { setLogin(false) }} sx={{float: 'right'}}>
        <CloseIcon /> 
      </IconButton>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={2}

      >

        <Grid xs={12} item sx={{padding:  0}}>

          <Typography variant= {matches ? 'h4' : 'h5'}  sx={{padding:  0 }} align="center" color='primary'>
            Login     
          </Typography>
    
        </Grid>
        <Grid xs={8} item style={{ margin: matches ? "0 auto" : 0 }}>
          <hr style={{ height: "1px", color: "primary", width: "100%" }}></hr>
        </Grid>
        <Grid xs={8} item >
          <TextField
            sx={{ textAlign: 'left', alignItems: 'left',  p: 0, noArrows }}
            type="text"
            value={regNumber}
            onChange={(e: any) => {
              setErr("");
              if (!/^[0-9]*$/.test(e.target.value)) {
                return
                const msg = "Registration number should be numbers only";
                return setErr(msg);
              }
              if (e.target.value.length <= 7) {
              setRegNumber(e.target.value);
              return;
              } else {
                return
                const msg = "Registration number should not be more than 7 digits";
                return setErr(msg);
              }
              setRegNumber(e.target.value);
            }}

            fullWidth
            // placeholder={'Registration number'}
          />
          <FormHelperText  >Registration Number</FormHelperText>
        </Grid>
        <Grid xs={8} item style={{}}>
          <OutlinedInput
            type={showPassword ? "text" : "password"}
            onChange={(e: any) => {
              setErr("");
              setPassword(e.target.value);
            }}
            value={password}

            fullWidth
            inputProps={{
              helpertext: "ksdjfjf"
            }}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword(true)}
                  onMouseDown={() => setShowPassword(false)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
          <FormHelperText>Password</FormHelperText>
        </Grid>
         <Grid xs={8} item style={{}}>
                <FormControlLabel
                  control={
                    <Checkbox
                      value={isRobot}
                      onChange={() => {
                        setErr("");
                        setIsRobot(!isRobot);
                      }}
                    />
                  }
                  label={notRobot}
                />{" "}
              </Grid> 
        <Grid xs={8} item>
          <ActionButton local_error={err} action={submit} name={"Login"} />
        </Grid>
      </Grid>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={2}
        style={{ padding: 20 }}
      >
        <Grid sm={8} item style={{ paddingRight: 16 }}>
          <Link style={linkStyle} to="/registration">
            Create an Account
          </Link>
        </Grid>
        <Grid xs={8} item style={{ paddingRight: 16 }}>
          <Link style={linkStyle} to="/password_remind">
            Forgot Password
          </Link>
        </Grid>
        {/* <Grid xl={8} lg={8} md={8} xs={8} sm={8} item style={{ paddingRight: 16 }}>
                <Link style={linkStyle} to="/instruction">
                  Registration Instructions
                </Link>
              </Grid> */}
        <Grid xs={8} item style={{}}>
          <Typography sx={linkStyle1}>© Claims Conference All Rights Reserved</Typography>
        </Grid>
      </Grid>
    </Paper>
    </>
  );
}